import React from 'react';
import Slide from '@material-ui/core/Slide';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import { Button } from 'antd';
import { useSelector } from 'react-redux';
import { firebaseFunctions } from '../../config/firebaseFunctions';
import { httpsCallable } from 'firebase/functions';
import { toast } from 'react-toastify';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function NftNotPublicDialog({
  isOpened = false,
  handleClose = () => null,
  isNftNotPublicLoading,
  activeInMarketPlace = false,
  activeNft,
  setwalletOwnedNfts,
  walletOwnedNfts,
  setNftNotPublicLoading,
}) {
  const userWalletRedux = useSelector((state) => state.walletReducer);
  const userAuthToken = useSelector((state) => state.authReducer.userauthtoken);

  const handleSetToNotPublic = async () => {
    setNftNotPublicLoading(true);
    const { nftIndex, nftData } = activeNft;

    console.log('nftdata', nftData);
    //updating db
    let dataArr = [
      {
        sn: nftData.index ? nftData.index : 1,
        nftId: nftData.nftId ? nftData.nftId : null,
        activeInMarketPlace: nftData.activeInMarketPlace,
      },
    ];

    let constantData = {
      to: nftData.activeInMarketPlace ? userWalletRedux.paymail : null,
      amount: Number(nftData.price),
      type: 'TOKEN',
      notes: nftData.activeInMarketPlace
        ? `sending to ${userWalletRedux.paymail}`
        : '',
      tokenId: nftData.tokenId,
      isMultiple: nftData.isMultiple,
      address: userWalletRedux.paymail,
      usersId: nftData.usersId,
      nftSaleType: nftData.nftSaleType,
      minBiddingPrice: nftData.minBiddingPrice
        ? Number(nftData.minBiddingPrice)
        : '',
    };

    console.log(
      'calling ',
      nftData.activeInMarketPlace
        ? 'musicartMakeNFTInActive'
        : 'musicartMakeNFTActive',
    );
    let musicartMakeNFTActiveApi = httpsCallable(
      firebaseFunctions,
      nftData.activeInMarketPlace
        ? 'musicartMakeNFTInActive'
        : 'musicartMakeNFTActive',
      {
        timeout: 300000,
      },
    );

    let apiRes = await musicartMakeNFTActiveApi({
      userAuthToken: userAuthToken,
      dataArray: dataArr,
      constantData,
    });

    console.log('apiRes', apiRes);
    if (apiRes.data.status === 'success') {
      setwalletOwnedNfts((prev) => {
        return [
          ...prev.map((nData, index) => {
            if (index === nftIndex) {
              return {
                ...nData,
                activeInMarketPlace: !nData.activeInMarketPlace,
              };
            }
            return nData;
          }),
        ];
      });

      setNftNotPublicLoading(false);
      handleClose();
    } else {
      toast.error(apiRes?.data?.msg ? apiRes.data.msg : 'An error occured!', {
        position: 'bottom-left',
        autoClose: 10000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        zIndex: 2147483641,
      });
      setNftNotPublicLoading(false);
    }
  };

  return (
    <Dialog
      open={isOpened}
      TransitionComponent={Transition}
      keepMounted={false}
      onClose={handleClose}
      aria-labelledby="alert-dialog-slide-title"
      aria-describedby="alert-dialog-slide-description"
      fullWidth
      style={{ zIndex: 1000 }}
      maxWidth="sm"
    >
      <div className="dialog-titlebar-medium">
        <div className="dialog-title-medium">Confirmation</div>
      </div>

      <div className="bg-blueGray-100">
        <p className="mt-6 text-md leading-relaxed text-blueGray-600 delete_box_padding">
          Are you sure, you want to make this NFT{' '}
          {activeInMarketPlace ? 'not public' : 'public'}?
        </p>
        <DialogActions
          style={{
            marginTop: 10,
            height: 50,
          }}
        >
          <div
            style={{
              minWidth: 100,
              textAlign: 'center',
              display: 'flex',
            }}
          >
            <Button
              className="bg-blueGray-700 active:bg-blueGray-600 uppercase text-white font-bold hover:shadow-md shadow text-xs px-4 py-2 rounded outline-none focus:outline-none sm:mr-2 mb-1 ease-linear transition-all duration-150"
              style={{
                borderColor: 'rgba(51, 65, 85, 1)',
                background: 'rgba(51, 65, 85,1)',
                color: '#fff',
              }}
              onClick={handleClose}
            >
              Cancel
            </Button>
            <div
              style={{
                display: 'flex',
                minWidth: 90,
                justifyContent: 'center',
              }}
            >
              <Button
                className="bg-blueGray-700 active:bg-blueGray-600 uppercase text-white font-bold hover:shadow-md shadow text-xs px-4 py-2  rounded outline-none focus:outline-none sm:mr-2 mb-1 ease-linear transition-all duration-150 update-button"
                style={{
                  borderColor: 'rgba(51, 65, 85, 1)',
                  background: 'rgba(51, 65, 85,1)',
                  color: '#fff',
                  display: 'flex',
                }}
                loading={isNftNotPublicLoading}
                onClick={() => {
                  handleSetToNotPublic();
                }}
              >
                Update
              </Button>
            </div>
          </div>
        </DialogActions>
      </div>
    </Dialog>
  );
}
